module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_tool2.974ff.png";